import '../../utils/index.mjs';
import _sfc_main from './src/dialog2.mjs';
export { useDialog } from './src/use-dialog.mjs';
export { dialogEmits, dialogProps } from './src/dialog.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElDialog = withInstall(_sfc_main);

export { ElDialog, ElDialog as default };
//# sourceMappingURL=index.mjs.map
